import React from 'react';
import './App.css';
import { Button, Form, FormGroup, Label, Input, FormText } from 'reactstrap';
import { BrowserRouter as Router, Route, Link, HashRouter, Switch } from "react-router-dom";
import {Provider} from 'react-redux';
import configureMockStore from "redux-mock-store";
import configureStore from "./modules/store/configureStore";
import {createBrowserHistory} from 'history';


import Full from './containers/Full/Full'
import Landing from './components/Landing';
import SignUpBuyer from './components/SignUpBuyer';
import SignUpSeller from './components/SignUpSeller';
import SignIn from './components/SignIn';
import UserDetail from './components/UserDetail';
import DashboardBuyer from './components/DashboardBuyer';
import DashboardSeller from './components/DashboardSeller';
import Welcome from './components/Welcome';

import './styles/misc.scss';

const history = createBrowserHistory();
const {store, persistor} = configureStore(
    {},{history});

// const mockStore = configureMockStore();
// const store = mockStore({});

function App() {
    return (
            <Provider store={store}>
                <Router>
                        <Switch>
                            {/*Dashboard, profile, history, schedule, 등을 제외한 다른 페이지들은 header가 필요하지 않으므로 이 곳에 route*/}
                            <Route path="/" exact component={Landing} />
                            <Route path="/signup/buyer" exact component={SignUpBuyer} />
                            <Route path="/signup/seller" exact component={SignUpSeller} />
                            {/*<Route path="/dashboard/buyer" exact component={DashboardBuyer} />*/}
                            {/*<Route path="/dashboard/buyer" exact component={DashboardSeller} />*/}
                            <Route path="/signin/" exact component={SignIn} />
                            <Route path="/detail/" exact component={UserDetail} />
                            <Route path="/welcome/" exact component={Welcome} />
                            <Route path="/" component={Full}/>
                        </Switch>
                </Router>
            </Provider>
    );
}


// function App() {
  // return (
  //     <Form>
  //         <FormGroup>
  //             <Label for="exampleEmail">Email</Label>
  //             <Input type="email" name="email" id="exampleEmail" placeholder="with a placeholder" />
  //         </FormGroup>
  //         <FormGroup>
  //             <Label for="examplePassword">Password</Label>
  //             <Input type="password" name="password" id="examplePassword" placeholder="password placeholder" />
  //         </FormGroup>
  //         <FormGroup>
  //             <Label for="exampleSelect">Select</Label>
  //             <Input type="select" name="select" id="exampleSelect">
  //                 <option>1</option>
  //                 <option>2</option>
  //                 <option>3</option>
  //                 <option>4</option>
  //                 <option>5</option>
  //             </Input>
  //         </FormGroup>
  //         <FormGroup>
  //             <Label for="exampleSelectMulti">Select Multiple</Label>
  //             <Input type="select" name="selectMulti" id="exampleSelectMulti" multiple>
  //                 <option>1</option>
  //                 <option>2</option>
  //                 <option>3</option>
  //                 <option>4</option>
  //                 <option>5</option>
  //             </Input>
  //         </FormGroup>
  //         <FormGroup>
  //             <Label for="exampleText">Text Area</Label>
  //             <Input type="textarea" name="text" id="exampleText" />
  //         </FormGroup>
  //         <FormGroup>
  //             <Label for="exampleFile">File</Label>
  //             <Input type="file" name="file" id="exampleFile" />
  //             <FormText color="muted">
  //                 This is some placeholder block-level help text for the above input.
  //                 It's a bit lighter and easily wraps to a new line.
  //             </FormText>
  //         </FormGroup>
  //         <FormGroup tag="fieldset">
  //             <legend>Radio Buttons</legend>
  //             <FormGroup check>
  //                 <Label check>
  //                     <Input type="radio" name="radio1" />{' '}
  //                     Option one is this and that—be sure to include why it's great
  //                 </Label>
  //             </FormGroup>
  //             <FormGroup check>
  //                 <Label check>
  //                     <Input type="radio" name="radio1" />{' '}
  //                     Option two can be something else and selecting it will deselect option one
  //                 </Label>
  //             </FormGroup>
  //             <FormGroup check disabled>
  //                 <Label check>
  //                     <Input type="radio" name="radio1" disabled />{' '}
  //                     Option three is disabled
  //                 </Label>
  //             </FormGroup>
  //         </FormGroup>
  //         <FormGroup check>
  //             <Label check>
  //                 <Input type="checkbox" />{' '}
  //                 Check me out
  //             </Label>
  //         </FormGroup>
  //         <Button>Submit</Button>
  //     </Form>
  // );
// }

export default App;
